import axios from '@/libs/api.request'
//行业列表
export const apiIndustryList = data => {
    return axios.request({
      url: '/industry/list',
      method: 'post',
      data
    })
  }
  //上下移动
  export const apiIndustryProductMove = data => {
    return axios.request({
      url: '/industry/product-move',
      method: 'post',
      data
    })
  }

  //保存
  export const apiIndustrySave = data => {
    return axios.request({
      url: '/industry/save',
      method: 'post',
      data
    })
  }
    //修改
    export const apiIndustryUpdate = data => {
      return axios.request({
        url: '/industry/update',
        method: 'post',
        data
      })
    }

    //删除
    export const apiIndustryDelete = data => {
        return axios.request({
          url: '/industry/delete',
          method: 'post',
          data
        })
      }